<template>
    <div>
        <back v-if="showToolbar" title="Login" route="/"></back>
        <login :add-to-cart="addToCart" :open-cart="openCart" :event-name="eventName"></login>
    </div>
</template>

<script>
    import Login from "../components/Login";
    export default {
        components: {Login},
        props :{
          showToolbar : {
              type : Boolean,
              default : true
          },
          showRegisterButton  : {
              type : Boolean,
              default : true
          },
          addToCart : {
              type : Boolean,
              default : false,
          },
          openCart : {
              type : Boolean,
              default : false,
          },
            eventName: {
                type : String,
                default : 'event',
            }
        },
        data(){
            return {

            }
        }
    }

</script>

<style lang="scss" scoped>
    @import "../scss/app.scss";

</style>
